/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateSupportingExaminationDto
 */
export interface CreateUpdateSupportingExaminationDto {
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateSupportingExaminationDto
     */
    lp?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSupportingExaminationDto
     */
    type?: CreateUpdateSupportingExaminationDtoTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSupportingExaminationDto
     */
    examKind?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSupportingExaminationDto
     */
    examKindDictId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSupportingExaminationDto
     */
    referralDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSupportingExaminationDto
     */
    consultationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSupportingExaminationDto
     */
    result?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSupportingExaminationDto
     */
    examId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSupportingExaminationDto
     */
    diagnosis?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSupportingExaminationDto
     */
    purpose?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSupportingExaminationDto
     */
    codeICD?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSupportingExaminationDto
     */
    printReferral: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSupportingExaminationDto
     */
    withoutSign: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSupportingExaminationDto
     */
    pdfTemplateType?: CreateUpdateSupportingExaminationDtoPdfTemplateTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSupportingExaminationDto
     */
    doctorUid?: string | null;
}


/**
 * @export
 */
export const CreateUpdateSupportingExaminationDtoTypeEnum = {
    helpExam: 'helpExam',
    specialisedConsultation: 'specialisedConsultation'
} as const;
export type CreateUpdateSupportingExaminationDtoTypeEnum = typeof CreateUpdateSupportingExaminationDtoTypeEnum[keyof typeof CreateUpdateSupportingExaminationDtoTypeEnum];

/**
 * @export
 */
export const CreateUpdateSupportingExaminationDtoPdfTemplateTypeEnum = {
    art_82_ust_1: 'art_82_ust_1',
    art_82_uprzywilejowany: 'art_82_uprzywilejowany',
    art_82_instruktor_egzaminator: 'art_82_instruktor_egzaminator',
    art_39_transport_drogowy: 'art_39_transport_drogowy',
    medycyna_pracy: 'medycyna_pracy',
    karta_badania_psychologicznego: 'karta_badania_psychologicznego',
    karta_broni: 'karta_broni',
    bron_orzeczenie_lekarskie: 'bron_orzeczenie_lekarskie',
    bron_orzeczenie_psychologiczne: 'bron_orzeczenie_psychologiczne',
    bron_karta_badania_psychologicznego: 'bron_karta_badania_psychologicznego',
    karta_badania_profilaktycznego: 'karta_badania_profilaktycznego',
    mp_orzeczenie_lekarskie_43: 'mp_orzeczenie_lekarskie_43',
    mp_orzeczenie_lekarskie_43_ang: 'mp_orzeczenie_lekarskie_43_ang',
    mp_orzeczenie_lekarskie_43_transport: 'mp_orzeczenie_lekarskie_43_transport',
    kierowca_orzeczenie_lekarskie_art_75_uprzywilejowany: 'kierowca_orzeczenie_lekarskie_art_75_uprzywilejowany',
    kierowca_orzeczenie_lekarskie_art_75_reszta: 'kierowca_orzeczenie_lekarskie_art_75_reszta',
    mp_zaswiadczenie_lekarskie_student: 'mp_zaswiadczenie_lekarskie_student',
    orzeczenie_sanitarno_epidemiologiczne: 'orzeczenie_sanitarno_epidemiologiczne',
    karta_badania_kierowcy: 'karta_badania_kierowcy',
    konsultacja_neurologiczna: 'konsultacja_neurologiczna',
    konsultacja_laryngologiczna: 'konsultacja_laryngologiczna',
    konsultacja_okulistyczna: 'konsultacja_okulistyczna',
    konsultacja_psychiatryczna: 'konsultacja_psychiatryczna',
    karta_odpowiedzi: 'karta_odpowiedzi',
    karta_badania_sanitarno_epidemiologicznego: 'karta_badania_sanitarno_epidemiologicznego',
    zaswiadczenie_lekarskie_zdolnosci_do_pracy: 'zaswiadczenie_lekarskie_zdolnosci_do_pracy',
    zaswiadczenie_sportowe: 'zaswiadczenie_sportowe',
    karta_badania_sportowego: 'karta_badania_sportowego',
    orzeczenie_stan_zdrowia_lekarza: 'orzeczenie_stan_zdrowia_lekarza',
    zaswiadczenie_stan_zdrowia_pielegniarka: 'zaswiadczenie_stan_zdrowia_pielegniarka',
    zaswiadczenie_stan_zdrowia_pielegniarka_art31: 'zaswiadczenie_stan_zdrowia_pielegniarka_art31',
    rejestrOrzeczen: 'rejestrOrzeczen',
    rejestrMedycynaPracy: 'rejestrMedycynaPracy',
    rejestrKierowcow: 'rejestrKierowcow',
    rejestrUczniowieStudenci: 'rejestrUczniowieStudenci',
    skierowanie_uczen: 'skierowanie_uczen',
    skierowanie_uczen_sanitarne: 'skierowanie_uczen_sanitarne',
    skierowanie_pracownik: 'skierowanie_pracownik',
    skierowanie_pracownik_sanitarne: 'skierowanie_pracownik_sanitarne',
    wynik_widzenia_zmierzchowego: 'wynik_widzenia_zmierzchowego',
    wybuch_cywilne_orzeczenie_lekarskie: 'wybuch_cywilne_orzeczenie_lekarskie',
    wybuch_cywilne_orzeczenie_psychologiczne: 'wybuch_cywilne_orzeczenie_psychologiczne',
    wybuch_wojsko_orzeczenie_lekarskie: 'wybuch_wojsko_orzeczenie_lekarskie',
    wybuch_wojsko_orzeczenie_psychologiczne: 'wybuch_wojsko_orzeczenie_psychologiczne',
    detektyw_orzeczenie_lekarskie: 'detektyw_orzeczenie_lekarskie',
    detektyw_orzeczenie_psychologiczne: 'detektyw_orzeczenie_psychologiczne',
    zestawienie_orzeczen: 'zestawienie_orzeczen',
    lista_firm: 'lista_firm',
    skierowanie_do_poradni: 'skierowanie_do_poradni',
    strazak_orzeczenie_lekarskie: 'strazak_orzeczenie_lekarskie',
    kierowca_rajdowy_orzeczenie_psychologiczne: 'kierowca_rajdowy_orzeczenie_psychologiczne',
    nauczyciel_poratowanie_zdrowia: 'nauczyciel_poratowanie_zdrowia',
    zaswiadczenie_okulary: 'zaswiadczenie_okulary',
    faktura_pl: 'faktura_pl',
    korekta_pl: 'korekta_pl'
} as const;
export type CreateUpdateSupportingExaminationDtoPdfTemplateTypeEnum = typeof CreateUpdateSupportingExaminationDtoPdfTemplateTypeEnum[keyof typeof CreateUpdateSupportingExaminationDtoPdfTemplateTypeEnum];


/**
 * Check if a given object implements the CreateUpdateSupportingExaminationDto interface.
 */
export function instanceOfCreateUpdateSupportingExaminationDto(value: object): value is CreateUpdateSupportingExaminationDto {
    if (!('printReferral' in value) || value['printReferral'] === undefined) return false;
    if (!('withoutSign' in value) || value['withoutSign'] === undefined) return false;
    return true;
}

export function CreateUpdateSupportingExaminationDtoFromJSON(json: any): CreateUpdateSupportingExaminationDto {
    return CreateUpdateSupportingExaminationDtoFromJSONTyped(json, false);
}

export function CreateUpdateSupportingExaminationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateSupportingExaminationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lp': json['lp'] == null ? undefined : json['lp'],
        'type': json['type'] == null ? undefined : json['type'],
        'examKind': json['examKind'] == null ? undefined : json['examKind'],
        'examKindDictId': json['examKindDictId'] == null ? undefined : json['examKindDictId'],
        'referralDate': json['referralDate'] == null ? undefined : (new Date(json['referralDate'])),
        'consultationDate': json['consultationDate'] == null ? undefined : (new Date(json['consultationDate'])),
        'result': json['result'] == null ? undefined : json['result'],
        'examId': json['examId'] == null ? undefined : json['examId'],
        'diagnosis': json['diagnosis'] == null ? undefined : json['diagnosis'],
        'purpose': json['purpose'] == null ? undefined : json['purpose'],
        'codeICD': json['codeICD'] == null ? undefined : json['codeICD'],
        'printReferral': json['printReferral'],
        'withoutSign': json['withoutSign'],
        'pdfTemplateType': json['pdfTemplateType'] == null ? undefined : json['pdfTemplateType'],
        'doctorUid': json['doctorUid'] == null ? undefined : json['doctorUid'],
    };
}

export function CreateUpdateSupportingExaminationDtoToJSON(value?: CreateUpdateSupportingExaminationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lp': value['lp'],
        'type': value['type'],
        'examKind': value['examKind'],
        'examKindDictId': value['examKindDictId'],
        'referralDate': value['referralDate'] == null ? undefined : ((value['referralDate'] as any).toISOString()),
        'consultationDate': value['consultationDate'] == null ? undefined : ((value['consultationDate'] as any).toISOString()),
        'result': value['result'],
        'examId': value['examId'],
        'diagnosis': value['diagnosis'],
        'purpose': value['purpose'],
        'codeICD': value['codeICD'],
        'printReferral': value['printReferral'],
        'withoutSign': value['withoutSign'],
        'pdfTemplateType': value['pdfTemplateType'],
        'doctorUid': value['doctorUid'],
    };
}

